import {ChangeDetectionStrategy, Component, computed, inject, Signal} from "@angular/core";
import {Page} from "../../navigation/page";
import {ButtonComponent} from "../../buttons/button/button.component";
import {ButtonProminence} from "../../buttons/button/button";
import {OrderingContextModel} from '../../ordering-context/ordering-context.model';
import {ModalPageLayoutComponent} from '../../page-layout/modal-page-layout/modal-page-layout.component';
import {PageFooterControlDirective} from '../../page-layout/page-footer-control.directive';
import {IconComponent} from '../../ui-elements/icon/icon.component';
import {MenuModel} from '../menu.model';

@Component({
    selector: "woa-rsa-block-page",
    templateUrl: "./rsa-block-page.component.html",
    styleUrl: "./rsa-block-page.component.scss",
    providers: [{provide: Page, useExisting: RsaBlockPageComponent}],
    imports: [
        ButtonComponent,
        ModalPageLayoutComponent,
        PageFooterControlDirective,
        IconComponent
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RsaBlockPageComponent extends Page {
    public orderingContextModel: OrderingContextModel = inject(OrderingContextModel);
    private menuModel: MenuModel = inject(MenuModel);

    ButtonProminence = ButtonProminence;

    public readonly title: Signal<string> = computed<string>(() =>
        this.menuModel.rsaBlocked() ? "woa.heading.rsa-block.title.remove" : "woa.heading.rsa-block.title.add");

    public readonly content: Signal<string> = computed<string>(() =>
        this.menuModel.rsaBlocked() ? "woa.message.rsa-block.remove" : "woa.message.rsa-block.add");

    public readonly okButtonLabel: Signal<string> = computed<string>(() =>
        this.menuModel.rsaBlocked() ? "woa.button.rsa-block.remove" : "woa.button.rsa-block.add");
}
